module.exports = __webpack_public_path__ + "static/media/ns-logo.8448b4eb.png";